import Vue from 'vue'
import router from './router'
import Plugin from './plugins'
import Carousel from 'bootstrap-sass/assets/javascripts/bootstrap/carousel'
import App from './App.vue'

// pages
// import homepageJs from './home'

Promise = require('es6-promise').Promise;

require('./style/index.scss')
require('animate.css/animate.css')
require('imports?jQuery=jquery!bootstrap-sass'); // Bootstrap js

router.start(App, '#app')

$(document).ready(function() {
  let navbarHeight = $('#navbar').height()
  $('#landing-slider').css('height', window.innerHeight - navbarHeight)
})



// WEBPACK FOOTER //
// ./assets/main.js